@let error = hasError();
@let hasDocument = hasDocuments();
@let doc = directusInvitationUploadDocument();
@let mandatory = isCardMandatory();

<div
  class="upload-card"
  [class.state-success]="hasDocument"
  [class.state-danger]="!hasDocument"
  [class.error]="error"
  [class.mandatory]="mandatory"
>
  @if (isEditable()) {
    @if (hasDocument) {
      <div class="status-icon success">
        <i class="pi pi-check-circle"></i>
      </div>
    } @else if (mandatory) {
      <div class="status-icon required">
        <app-directus-tooltip
          icon="pi pi-exclamation-circle"
          tooltipKey="common.mandatory"
        ></app-directus-tooltip>
      </div>
    }
  }

  <div class="card-header">
    <div class="icon-container">
      <i class="pi icon" [ngClass]="doc.icon"></i>
    </div>

    <div class="text-container">
      <div class="title-row">
        <h3>{{ title() }}</h3>

        @let tooltipText = doc.translations | translateDirectus: 'tooltip' : true;

        @if (tooltipText) {
          <i class="pi pi-info-circle" [pTooltip]="tooltipText"></i>
        }
      </div>

      <p class="subtitle">
        {{ doc.translations | translateDirectus: 'subtitle' }}
      </p>
    </div>
  </div>

  <div class="documents">
    @for (document of uploadedDocuments(); track document.id) {
      <app-document-item
        [document]="document"
        [documentType]="doc.translations"
        [isEditable]="isEditable()"
        (previewItem)="previewFile.emit($event)"
        (downloadItem)="downloadFile.emit($event)"
        (editItem)="onEdit($event)"
        (deleteItem)="deleteFile.emit($event)"
      ></app-document-item>
    }
  </div>

  @if (isEditable()) {
    <button
      type="button"
      class="upload-area"
      (click)="triggerUpload()"
      (dragover)="$event.preventDefault(); $event.stopPropagation()"
      (drop)="onFileDropped($event)"
    >
      <div class="upload-content">
        <i class="pi pi-upload upload-icon"></i>

        <p class="upload-text">
          {{ (hasDocument ? 'common.clickToAddMore' : 'common.clickToUpload') | transloco }}
        </p>

        <p class="upload-hint">{{ 'project.steps.rfq.invitationPreview.file.hint' | transloco }}</p>
      </div>

      <input
        type="file"
        #fileInput
        class="hidden"
        tabindex="-1"
        accept=".pdf,application/pdf"
        (change)="onFileSelected($event)"
      />
    </button>
  }
</div>
